<div class="modal-header mb-ng-modal-header">
  <div class="modal-title mb-ng-modal-title"
       data-cy="mb-ng-modal-title">
    <span>{{'mbProductTabs.allPublications' | mbTranslate}}</span>
  </div>
  <button type="button"
          class="mb-ng-modal-close close"
          aria-label="Close"
          data-cy="mb-ng-modal-close"
          (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body mb-ng-modal-body"
     data-cy="mb-ng-modal-body">
  <ng-container *ngIf="publications">
    <div class="d-inline">
      <a *ngFor="let publication of publications"
         class="mr-4"
         [href]="publication?.url"
          target="_blank">
        {{publication?.name}}
      </a>
    </div>
  </ng-container>
</div>
